<template>
    <section class="section_director">
        <h2 class="section--title text-center"><strong>Director</strong></h2>

        <div class="section_director--main">
            <div class="grid-container">
                <div class="grid-x grid-padding-x align-center">
                    <section class="cell small-12 medium-10">
                        <article class="director_article grid-x grid-padding-x align-center">
                            <figure class="cell small-4 show-for-medium">
                                <img :src="item.image" :alt="item.nameKanji">
                            </figure>
                            <section class="director_article--section cell small-12 medium-8">
                                <h3 class="director_article--title" v-html="item.name"></h3>
                                <figure class="director_article--image hide-for-medium">
                                    <img :src="item.image" :alt="item.nameKanji">
                                </figure>
                                <p class="director_article--content show-for-medium" v-html="item.description"></p>
                            </section>
                            <p class="cell small-12 director_article--content hide-for-medium" v-html="item.description"></p>
                        </article>
                        <section class="comment_article">
                            <h3 class="comment_article--title"><img src="/netemosametemo/static/img/comment.png" alt="Comment"><strong class="seo">Comment</strong></h3>
                            <p class="comment_article--content" v-html="item.comment"></p>
                        </section>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'director',
    data () {
        return {
            item: {
                nameKanji: '監督：濱口竜介',
                name: 'RYUSUKE HAMAGUCHI<strong><span>監督：</span>濱口竜介</strong><small>（はまぐち・りゅうすけ）</small>',
                description: '1978年12月16日、神奈川県生まれ。<br>2008年、東京藝術大学大学院映像研究科の修了制作『PASSION』がサン・セバスチャン国際映画祭や東京フィルメックスに出品され高い評価を得る。その後も日韓共同制作『THE DEPTHS』が東京フィルメックスに出品、東日本大震災の被害者へのインタヴューから成る『なみのおと』『なみのこえ』、東北地方の民話の記録『うたうひと』（共同監督：酒井耕）、4時間を超える長編『親密さ』、染谷将太を主演に迎えた『不気味なものの肌に触れる』を監督。15年、映像ワークショップに参加した演技経験のない女性4人を主演に起用した5時間17分の長編『ハッピーアワー』を発表し、ロカルノ、ナント、シンガポールほか国際映画祭で主要賞を受賞。一躍その名を世に知らしめた。自らが熱望した小説「寝ても覚めても」の映画化である本作で、満を持して商業デビュー。第71回カンヌ国際映画祭コンペティション部門に選ばれるという快挙を果たし、世界中から熱い注目を集めている。',
                comment: '他者同士が「自身の感情を尊重する」なら、一緒にいることは単に喜びをもたらすだけでなく、互いを破壊するような暴力性も同時に持つ。その恋愛の困難さを真正面から扱っていることが原作『寝ても覚めても』が最高の恋愛小説たる所以であり、私が映画化を熱望した理由です。『寝ても覚めても』の中の恋人たちは、恋すること・愛することを通じて、日常／非日常の境が崩壊したあとの「次の瞬間何が起こるかわからない」過酷な生へと、決然と踏み出していきます。それはフィクションだから可能な荒唐無稽なのでしょうか。ただ、映画の中の東出さんと唐田さんをずっと見ていると、私はそれが単にフィクションではないような気持ちになります。ラストの二人の表情を見ると、映画『寝ても覚めても』もまた最高の恋愛映画になった、と私は思うのです。素晴らしい原作とキャストの出会いに、心より感謝します。',
                image: '/netemosametemo/static/img/hamaguchi_img.jpg'
            }
        }
    },

    methods: {
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Director.vue